import api from './api';

export const listAdminCourses = () =>
  api.get('/admin/courses').then(r => r.data.courses);

export const getAdminCourseDetail = (id) =>
  api.get(`/admin/courses/${id}`).then(r => r.data.course);

export const createAdminCourse = (fields) =>
  api.post('/admin/courses', fields).then(r => r.data.course);

export const updateAdminCourse = (id, fields) =>
  api.put(`/admin/courses/${id}`, fields).then(r => r.data.course);

export const deleteAdminCourse = (id) =>
  api.delete(`/admin/courses/${id}`);

export const createAdminLesson = (courseId, fields) =>
  api.post(`/admin/courses/${courseId}/lessons`, fields).then(r => r.data.lesson);

export const updateAdminLesson = (lessonId, fields) =>
  api.put(`/admin/courses/lessons/${lessonId}`, fields).then(r => r.data.lesson);

export const deleteAdminLesson = (lessonId) =>
  api.delete(`/admin/courses/lessons/${lessonId}`);
